import { render, staticRenderFns } from "./VsDatepicker.vue?vue&type=template&id=1da2939e"
import script from "./VsDatepicker.vue?vue&type=script&lang=js"
export * from "./VsDatepicker.vue?vue&type=script&lang=js"
import style0 from "./VsDatepicker.vue?vue&type=style&index=0&id=1da2939e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports